module.exports = __webpack_public_path__ + "img/88be5a43370423cb2fe2476aea813fa6.svg";